<div class="image-upload">
  <andor-file-drop-zone
    class="upload-zone"
    bare
    accept="image/png, image/jpeg, image/svg+xml, image/webp"
    [ariaLabel]="description()"
    (filesSelected)="onFilesSelected($event)">
    <div class="upload-content description">
      {{ description() }}
    </div>
    <div class="upload-content files">
      @let current = item();
      <div class="file-header">
        <div class="file-info">
          @if (current) {
            <img [src]="current.url" class="preview-img" crossorigin="anonymous" />
            <div class="file-name">
              {{ current.name | slice: 0 : 25 }}
              @if (current.name.length > 25) {
                <span>...</span>
              }
            </div>
            @if (current.size !== undefined) {
              <div>({{ formatBytes(current.size) }})</div>
            }
          } @else {
            <fa-icon [icon]="faImage"></fa-icon>
            <span>{{ noFileSelectedText() }}</span>
          }
        </div>
        <div class="actions">
          @if (processing()) {
            <andor-icon-btn>
              <mat-spinner [diameter]="20" />
            </andor-icon-btn>
          } @else if (current?.removable) {
            <andor-icon-btn [tooltip]="'Delete image' | translate" (click)="removeItem($event)">
              <fa-icon class="duotone-error" [icon]="faXmark"></fa-icon>
            </andor-icon-btn>
          }
        </div>
      </div>
      @let message = error();
      @if (message) {
        <div class="status-message">{{ message }}</div>
      }
    </div>
  </andor-file-drop-zone>
</div>
